import { all } from 'redux-saga/effects'

import watchSync from './sync'

export default function* sagas() {
  yield all([watchSync()])
}
